export default __webpack_public_path__ + "static/media/windowslogo.098bfe53.svg";